const Subheader = (props) => {
  return <h2 className="subheader">{props.title}</h2>;
};

export default Subheader;